import React, { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import Form from "./Form";

function Home() {
  const handleChipClick = useOutletContext();

  useEffect(() => {
    handleChipClick("home");
  }, [handleChipClick]);

  return <Form />;
}

export default Home;
